"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackEvent = void 0;
const Bus = require("./Bus");
function TrackEvent(eventName, args = {}, value) {
    return Bus.trigger(Bus.ON_ANALYTICS, {
        eventName,
        args,
        value
    });
}
exports.TrackEvent = TrackEvent;
//# sourceMappingURL=Track.js.map